import { useBreakpointValue as useBaseBreakpointValue, UseBreakpointOptions } from '@chakra-ui/react';

type UseBreakpointValueOptions = Omit<UseBreakpointOptions, 'ssr'>;

export const useBreakpointValue = <T = any>(values: Partial<Record<string, T>> | Array<T | null>, options: UseBreakpointValueOptions = {}): T | undefined => {
	return useBaseBreakpointValue(values, { ssr: false, ...options });
};
